import { inject, NewInstance } from 'aurelia-framework';
import { MachineService } from 'pages/standard-setup/machines/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController, DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), MachineService, EventAggregator, PlantService, DialogService)
export class PartSizeEditor {
    constructor(controller, validationController, machineService, ea, plantService, dialogService) {
        this.controller = controller;
        this.machineService = machineService;
        this.plantService = plantService;
        this.dialogService = dialogService;
        this.ea = ea;
        this.machine = {
            plants: []
        };

        this.plantItems = [];

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('name').required()
            .rules;
    }

    addPlant () {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    async activate(model) {
        if (model?.id != null) {
            this.machine = await this.machineService.getById(model.id);
            if (this.machine.plants == null) {
                this.machine.plants = [];
            } else {
                this.plantItems = Object.keys(this.machine.plants).map((v, i) => ({ id: v, name: this.machine.plants[v] }));
                this.machine.plants = Object.keys(this.machine.plants);
            }
        }
    }
    
 

    async save() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.machine.id) {
                    await this.machineService.update(this.machine);
                    toastr.success('Machine was updated!');
                } else {
                    await this.machineService.create(this.machine);
                    toastr.success('New machine was created!');
                }
                this.ea.publish('machines:updated', this.machine);
                this.controller.ok(this.machine);
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}